<section class="pb-form">
    <div class="pb-container pb-py-6 lg:pb-py-0">
        <div class="lg:pb-mt-6">
            <div #FormLite class="swiper lg:pb-min-h-[615px] lg:pb-py-10">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="pb-min-h-[500px] pb-flex pb-flex-col lg:pb-flex-row lg:pb-justify-between pb-mb-13">
                            <div class="pb-mb-6 lg:pb-mb-0 lg:pb-w-2/5">
                                <div class="pb-p-5 pb-pb-10 pb-form-bubble pb-relative lg:pb-min-w-[382px] lg:pb-max-w-[707px]">
                                    <div *ngIf="rendering.fields?.Title?.value" class="pb-text-d-md-m lg:pb-text-d-md pb-text-color-brand pb-font-serif">{{ rendering.fields?.Title?.value }}</div>
                                    <div *ngIf="rendering.fields?.Subtitle?.value" class="pb-text-md-m lg:pb-text-md pb-mt-5 lg:pb-mt-4">{{ rendering.fields?.Subtitle?.value }}</div>
                                </div>
                                <img
                                    class="pb-hidden pb-mx-auto pb-w-fit pb-relative -pb-mt-[40px] pb-z-10 lg:pb-block pb-form-illustration lg:pb-h-[420px]"
                                    [src]="rendering.fields?.Image?.value?.src"
                                    [alt]="rendering.fields?.Image?.value?.alt"
                                />
                            </div>
                            <form [formGroup]="form" class="pb-flex pb-flex-col pb-gap-y-6 lg:pb-w-1/2">
                                <div
                                    app-form-text-input
                                    formControlName="name"
                                    [isRequired]="true"
                                    [maxLength]="50"
                                    [error]="isInputInvalid('name')"
                                    [helperText]="isInputInvalid('name') ? ('mandatory-field' | translate) : ''"
                                    [name]="'name'"
                                    [id]="'name'"
                                    [labelText]="rendering.fields?.NameLabel?.value"
                                    [isLarge]="true"
                                    [mask]="maskStringWithSpace"
                                ></div>
                                <div
                                    app-form-text-input
                                    formControlName="surname"
                                    [isRequired]="true"
                                    [error]="isInputInvalid('surname')"
                                    [helperText]="isInputInvalid('surname') ? ('mandatory-field' | translate) : ''"
                                    [name]="'surname'"
                                    [id]="'surname'"
                                    [labelText]="rendering.fields?.SurnameLabel?.value"
                                    [isLarge]="true"
                                    [maxLength]="100"
                                    [mask]="maskStringWithSpace"
                                ></div>
                                <div
                                    app-form-text-input
                                    formControlName="phone"
                                    [isRequired]="true"
                                    [error]="isInputInvalid('phone')"
                                    [helperText]="isInputInvalid('phone') ? ('mandatory-field' | translate) : ''"
                                    [name]="'phone'"
                                    [id]="'phone'"
                                    [mask]="{ mask: '00000000000000' }"
                                    [labelText]="rendering.fields?.PhoneLabel?.value"
                                    [isLarge]="true"
                                ></div>
                                <div
                                    app-form-text-input
                                    formControlName="email"
                                    [isRequired]="true"
                                    [error]="isInputInvalid('email')"
                                    [maxLength]="50"
                                    [helperText]="isInputInvalid('email') ? (form['controls']['email']?.errors?.required ? ('mandatory-field' | translate) : ('email-pattern' | translate)) : ''"
                                    [name]="'email'"
                                    [id]="'email'"
                                    [labelText]="rendering.fields?.EmailLabel?.value"
                                    [isLarge]="true"
                                ></div>
                                <div
                                    app-form-text-area
                                    formControlName="area"
                                    [isRequired]="true"
                                    [error]="isInputInvalid('area')"
                                    [helperText]="isInputInvalid('area') ? ('mandatory-field' | translate) : ''"
                                    [name]="'area'"
                                    [id]="'contactform-lite-area'"
                                    [labelText]="rendering.fields?.MessageLabel?.value"
                                    [placeholder]="rendering.fields?.MessagePlaceholder?.value"
                                    [maxLength]="rendering.fields?.MessageLimit?.value"
                                ></div>
                            </form>
                        </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="restart-swiper pb-mx-auto pb-text-color-brand pb-font-serif pb-text-d-lg pb-text-center pb-max-w-[836px]" *ngIf="callSuccess" data-completion="success">
                        <div class="pb-mb-12 lg:pb-mb-13" >{{rendering.fields?.FinalMessageSuccess?.value}}</div>
                        <img *ngIf="rendering.fields?.FinalImageSuccess?.value?.src" class="pb-flex pb-justify-center pb-mx-auto pb-max-w-xl pb-form-illustration"[src]="rendering.fields?.FinalImageSuccess?.value?.src" [alt]="rendering.fields?.FinalImageSuccess?.value?.alt"/>
                      </div>
                      <div class="restart-swiper pb-mx-auto pb-text-color-brand pb-font-serif pb-text-d-lg pb-text-center pb-max-w-[836px]" *ngIf="!callSuccess" data-completion="fail">
                        <div class="pb-mb-12 lg:pb-mb-13" >{{rendering.fields?.FinalMessageFailure?.value}}</div>
                        <img *ngIf="rendering.fields?.FinalImageFailure?.value?.src" class="pb-flex pb-justify-center pb-mx-auto pb-max-w-xl pb-form-illustration" [src]="rendering.fields?.FinalImageFailure?.value?.src" [alt]="rendering.fields?.FinalImageFailure?.value?.alt"/>
                      </div>
                    </div>
                </div>
                <button *ngIf="this.swiper?.activeIndex == 0" [disabled]="LoadingOnSubmit" type="button" (click)="Submit()" class="lg:pb-ml-auto pb-btn pb-btn--large pb-btn-primary-brand pb-w-full lg:pb-w-fit">
                    {{ rendering.fields?.ButtonLabel?.value }}
                    <i *ngIf="LoadingOnSubmit" class="pb-icon pb-icon-loading pb-animate-spin"></i>
                </button>
            </div>
        </div>
    </div>
</section>
